export const FILTER_SELECTOR_DROPDOWN_CLASSNAME = 'FILTER_SELECTOR_DROPDOWN_CLASSNAME';
export const LIST_FILTER_WRAPPER_CLASSNAME = 'LIST_FILTER_WRAPPER_CLASSNAME';
export const REVIEWS_FILTER_SEARCH_CLASSNAME = 'REVIEWS_FILTER_SEARCH_CLASSNAME';
export const TENDER_ID_FILTER_SEARCH_CLASSNAME = 'TENDER_ID_FILTER_SEARCH_CLASSNAME';
export const CONTRACTS_FILTER_SEARCH_CLASSNAME = 'CONTRACTS_FILTER_SEARCH_CLASSNAME';
